<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Give Feedback</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br>
            <v-data-table :headers="headers2" :items="feedback_list" class="elevation-1 mytable" dense>
                <template v-slot:item.isfeedbackgiven="{ item }">
                    <span v-if="item.isfeedbackgiven && item.isfeedbackgiven!='NA'">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                    </template>
             </v-data-table>
             <v-data-table :headers="headers" :items="crs_list" class="elevation-1 mytable" dense>
             </v-data-table>
              <center>
                <span v-if="isfeedbackgiven=='NA'">
                <v-btn class="mb-2 button" small @click="givefeedback(fid,crs_list)">Give Feedback</v-btn>
                </span>
                <span v-else-if="!isfeedbackgiven">
                <v-btn  class="mb-2 button" small @click="givefeedback(fid,crs_list)">Give Feedback</v-btn>
                </span>
                
              </center>
        </v-card>
        <span v-if="feedback_questions_and_option_list != null">
        <!-- <v-dialog v-model="give_feedback_flag" fullscreen>
        <v-card>
         <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Give Subject Feedback
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                 <v-btn fab small color="white" outlined icon @click="close()"><v-icon> mdi-close </v-icon></v-btn>
            </v-toolbar>
                <v-card class="box">
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Academic Year : </strong>{{feedback_list[0].academic_year}}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Feedback Type : </strong>{{feedback_list[0].feedbacktype}}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Feedback Number : </strong>{{feedback_list[0].feedback_number}}
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Subject Code : </strong>{{crs_list[crs_index].crs_code}}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Subject Name : </strong>{{crs_list[crs_index].crs_name}}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Teacher : </strong>{{crs_list[crs_index].crs_inst}}
                        </v-col>
                    </v-row>
                    
                    
                    <v-card class="box" v-for="(item,index) in feedback_questions_and_option_list" :key="index">
                        <v-row>
                            <v-col cols="12" sm="10" md="10">
                                <strong>Question N0.</strong>{{item.qno}} 
                                <span v-html="item.question_statement"></span>
                                
                            </v-col>
                            <v-col cols="12" sm="2" md="2"><strong>Marks</strong>{{item.weightage}}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <span class="crs"> <strong> Options </strong></span>
                                <span v-for="(opt,opt_index) in item.option_list" :key="opt_index">
                                    <v-row dense class="pl-2">
                                       
                                        <input @click="addSelection(item,opt)" class="radiospace"  type="radio"/>
                                        <span class="p-0 span-mr"  v-html="opt.option_statement">
                                           
                                        </span>
                                    </v-row>
                                </span>
                            </v-col>
                        </v-row>
                       
                    </v-card>
                </v-card>
                <v-row justify="center">
                    <v-btn class="button" @click="saveFeedback()">Save and Next</v-btn>
                    <v-btn class="button" @click="close()">Cancel</v-btn>
                </v-row>
                
        </v-card>
        </v-dialog> -->
        </span>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            overlay: false,
            give_feedback_flag: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            feedback_list:[],
            crs_list:[],
            selected_options:[],
            feedback_questions_and_option_list:null,
            isfeedbackgiven:null,
            fid:null,
            crs_index: 0,
            opt_id: "",
            crs_feedback:[],
            headers2:[
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "academic_year",
                },
                 {
                    text: "Feedback Type",
                    align: "left",
                    sortable: false,
                    value: "feedbacktype",
                },
                 {
                    text: "Feedback Number",
                    align: "left",
                    sortable: false,
                    value: "feedback_number",
                },
                {
                    text: "Feedback Title",
                    align: "left",
                    sortable: false,
                    value: "feedback_title",
                },
                 {
                    text: "Start Date",
                    align: "left",
                    sortable: false,
                    value: "startDate",
                },
                 {
                    text: "End Date",
                    align: "left",
                    sortable: false,
                    value: "endDate",
                },
                {
                    text: "Is Feedback Given",
                    align: "left",
                    sortable: false,
                    value: "isfeedbackgiven",
                },
            ],
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                 {
                    text: "Subject Code",
                    align: "left",
                    sortable: false,
                    value: "crs_code",
                },
                {
                    text: "Subject Name",
                    align: "left",
                    sortable: false,
                    value: "crs_name",
                },
                {
                    text: "Course Type",
                    align: "left",
                    sortable: false,
                    value: "crs_type",
                },
                 {
                    text: "Course Instructor",
                    align: "left",
                    sortable: false,
                    value: "crs_inst",
                },
            ],
        }),
        mounted() {
            this.onload();
        },
        methods: {
            close(){
                alert("close")
                this.give_feedback_flag = false
                this.selected_options = []
                
            },
            addSelection(item,opt){
                this.selected_options.push({
                    feedback_que_id: item.id,
                    opt_id: opt.opt_id
                })
                console.log(this.selected_options)
            },
            saveFeedback(){
                this.overlay = true
                // this.crs_feedback.push({
                //     crs_off_id: this.crs_list[this.crs_index].crs_offering,
                //     crs_off_learner: this.crs_list[this.crs_index].courseOfferingLearner,
                //     crs_off_inst: this.crs_list[this.crs_index].crs_inst_id,
                //     selected_options: this.selected_options,
                // })
                this.crs_index = this.crs_index + 1
                console.log(this.crs_feedback)
                this.overlay = false
                const data = {
                    fid: this.fid,
                    crs_off_id: this.crs_list[this.crs_index].crs_offering,
                    crs_off_learner: this.crs_list[this.crs_index].courseOfferingLearner,
                    crs_off_inst: this.crs_list[this.crs_index].crs_inst_id,
                    // feedback_que_id: item.id,
                    selected_options: this.selected_options
                }
                axios
                .post("/Feedback/saveSubjectFeedback", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", res.data.status_reason);
                        
                    }
                //    this.feedback_questions_and_option_list = res.data.feedback_questions_and_option_list
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    if (this.crs_list.length == this.crs_index) {
                        this.crs_index = 0
                    }else{
                        this.crs_index = this.crs_index+1
                    }
                   this.selected_options = []
                });
            },
            givefeedback(fid,crsList){
                this.give_feedback_flag = true

                //alert(fid)
                this.$session.set("fid", JSON.stringify(fid));
                this.$session.set("crsList", JSON.stringify(crsList));
                this.$session.set("feedback_list", JSON.stringify(this.feedback_list));
                this.$router.push({
                    name: "subject-feedback",
                });
                // const data={
                //     fid:fid,
                //     crs_off_id: crsList[this.crs_index].crs_offering
                // }
                // axios
                // .post("/Feedback/getCourseFeedBackQuestions", data)
                // .then((res) => {
                //    this.feedback_questions_and_option_list = res.data.feedback_questions_and_option_list
                // })
                // .catch((error) => {
                //     this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                // })
                // .finally(() => {
                   
                // });
            },
            onload() {
                 this.overlay = true;
                axios
                .post("/Feedback/getStudentFeedBack")
                .then((res) => {
                    if (res.data.flag == "YES") {
                       this.feedback_list=res.data.feedback_list
                       this.crs_list = res.data.crs_list
                       this.isfeedbackgiven = res.data.isfeedbackgiven;
                       this.fid = res.data.fid
                       this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status);
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    this.overlay = false;
                });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .span-mr {
        margin: 1rem !important;
        padding: 0px;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
</style>
